<div class="sb-chart" *ngIf="data">
  <div #sbHost [id]="$any(data).widgetId" class="sb-chart-host" [style.height]="hostHeight"></div>
</div>
